import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { validateEnvVariables } from './utils/envValidation'

// Validate environment variables on app start
validateEnvVariables()

// Renderizar la aplicación
const root = ReactDOM.createRoot(document.getElementById('root'))

// React.StrictMode causes double-mounting in development, which creates duplicate Firebase subscriptions
// This is intentional and helps ensure cleanup functions work correctly
// The cleanup functions in components (EventCard, ChatWindow, ComunidadGruposPage) properly handle this
const isDevelopment = import.meta.env.DEV

root.render(
  isDevelopment ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  ),
)